import {
  AdminCategory,
  ADMIN_CATEGORIES,
  displayNameForAPICategory,
} from "../../../models/Categories";
import { fetchWithAuth } from "../../../api-client/api_client";
import { APICategoryDisplay } from "../../../models/Entities";
import { getDjangoAdminBaseUrl } from "../../../utils";
import { BlueprintPriority, LookupMode, SyncPlanConfig, SyncPlanConfigBase } from "./types";

export const getSyncPlanConfigAdminUrl = (id: string) =>
  `${getDjangoAdminBaseUrl()}/integrations/syncplanconfiguration/${id}/change/`;

export const getCategoryDisplayName = (category: string): string =>
  displayNameForAPICategory(category as AdminCategory) ??
  (APICategoryDisplay as Record<string, string>)[category] ??
  category;

export const fetchJSON = <T>(path: string): Promise<T> =>
  new Promise((resolve, reject) => {
    fetchWithAuth({
      path,
      method: "GET",
      onResponse: resolve,
      onError: reject,
    });
  });

export const fetchFullSyncPlanConfig = (base: SyncPlanConfigBase): Promise<SyncPlanConfig> =>
  fetchJSON<BlueprintPriority[]>(
    `integrations/sync-plan-configurations/${base.id}/blueprint-priorities`
  ).then((priorities) => ({ ...base, blueprint_priorities: priorities }));

export const LOOKUP_MODE_LABELS: Record<LookupMode, string> = {
  linked_account: "Linked Account ID",
  sync_plan_config: "Sync Plan Configuration ID",
  integration: "Integration ID",
};

export const ALL_CATEGORIES: AdminCategory[] = ADMIN_CATEGORIES;
